import type { UseFormReturn } from 'react-hook-form';
import type { Metric } from '@gonfalon/metrics/types';

import { ClickMetricDetails } from './ClickMetricDetails';
import { CustomMetricKindDetails } from './CustomMetricKindDetails';
import type { MetricForm } from './formUtils';
import { PageviewMetricDetails } from './PageviewMetricDetails';

type MetricKindDetailsProps = {
  context: UseFormReturn<MetricForm>;
  metricKind: Metric['kind'];
};

export const MetricKindDetails: React.FC<MetricKindDetailsProps> = ({ context, metricKind }) => {
  if (metricKind === 'custom' || metricKind === 'trace') {
    return <CustomMetricKindDetails context={context} />;
  } else if (metricKind === 'click') {
    return <ClickMetricDetails context={context} />;
  } else if (metricKind === 'pageview') {
    return <PageviewMetricDetails context={context} />;
  }
  return null;
};
